/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ApiUserDashboardProfilePayloadFromJSON(json) {
    return ApiUserDashboardProfilePayloadFromJSONTyped(json, false);
}
export function ApiUserDashboardProfilePayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'dashboardProfileId': !exists(json, 'dashboardProfileId') ? undefined : json['dashboardProfileId'],
        'presetKey': !exists(json, 'presetKey') ? undefined : json['presetKey'],
    };
}
export function ApiUserDashboardProfilePayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'dashboardProfileId': value.dashboardProfileId,
        'presetKey': value.presetKey,
    };
}
